import { createContext } from "react";

const defaultDialogContext = {
    onClose: () => { },
    onBack: () => { },
}
export const DialogContext = createContext(defaultDialogContext);